import { render, staticRenderFns } from "./addNewDepartment.vue?vue&type=template&id=79d60b8e&scoped=true"
import script from "./addNewDepartment.vue?vue&type=script&lang=js"
export * from "./addNewDepartment.vue?vue&type=script&lang=js"
import style0 from "./addNewDepartment.vue?vue&type=style&index=0&id=79d60b8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d60b8e",
  null
  
)

export default component.exports